import { PessoaSocioModel } from "model/api/gestao/pessoa/pessoa-socio-model";
import { CardNaoEncontrado } from "views/components/cards";
import { CardPessoaSocio } from "views/components/cards/card-pessoa-socio";
import { InformacaoIcon } from "views/components/icons";

export interface ClienteSocioGridProps {
  list: Array<PessoaSocioModel>;
  carregando: boolean;
  selectedList: Array<string>;
  onCardSelected: (model: PessoaSocioModel) => void;
  onCardChecked: (id: string) => any;
}

export const AccordionClienteSocioListData = (props: ClienteSocioGridProps) => {

  const onCardSelected = (model: PessoaSocioModel) => {
    props.onCardSelected(model);
  };

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Sócio Cadastrado."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}
      {props?.list.length > 0 &&
        props.list.map((items, index) => {
          return (
            <CardPessoaSocio
              selected={
                props.selectedList.filter((item) => item === items.id).length >
                  0
                  ? true
                  : false
              }
              onCheck={onCardChecked}
              onClick={onCardSelected}
              model={items}
              key={index}
            />
          );
        })}
    </>
  );
};
